// extracted by mini-css-extract-plugin
module.exports = {"transition":"PageButton_transition__bJeon"};